import React from "react"
import { yupResolver } from "@hookform/resolvers/yup"
import { useMutation } from "@tanstack/react-query"
import { userUpdateProfile } from "api/authApi"
import LoadingButton from "components/Common/LoadingButton"
import InputRHF from "components/RHF/InputRHF"
import { update_profile_schema } from "helpers/validationSchema"
import { t } from "i18next"
import {  useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { Button, Card, CardBody, CardTitle, FormGroup } from "reactstrap"
import useAuth from "hooks/useAuth"

function UpdateProfilePage() {
  const { userData, updateUserData } = useAuth()
  const { handleSubmit, control } = useForm({
    defaultValues: {
      fullname: userData.fullname,
      email: userData.email,
      phone: userData.phone,
    },
    resolver: yupResolver(update_profile_schema),
  })

  const { mutate, isPending } = useMutation({
    mutationFn: userUpdateProfile,
    onSuccess: data => {
      updateUserData(data)
      toast.success(t("the information has been updated successfully"))
    },
    onError: error => toast.error(error),
  })

  const handleChangeImage = async event => {
    const promise = userUpdateProfile({
      image: event.target.files[0],
    })

    toast.promise(promise, {
      pending: t("uploading file"),
      success: {
        render({ data }) {
          updateUserData({ image: data.image })
          return t("the file has been uploaded")
        },
      },
      error: {
        render({ data }) {
          return data
        },
      },
    })
  }
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-3">{t("update your profile")}</CardTitle>
        <form onSubmit={handleSubmit(mutate)} id="form_id">
          <FormGroup>
            <div className="vstack d-inline-flex gap-1 w-auto">
              <img
                className="img-thumbnail rounded-circle avatar-xl"
                src={userData.image}
                data-holder-rendered="true"
                alt="200x200"
              />
              <Button
                className="btn-upload btn-soft-secondary"
                type="button"
                size="sm"
              >
                {t("change")}
                <input type="file" onChange={handleChangeImage} />
              </Button>
            </div>
          </FormGroup>

          <InputRHF
            name="fullname"
            label={t("full name")}
            control={control}
            placeholder={t("enter full name")}
          />
          <InputRHF
            name="phone"
            label={t("phone")}
            control={control}
            placeholder={t("enter enter phone number")}
          />
          <InputRHF
            type="email"
            name="email"
            label={t("email")}
            placeholder={t("example@gmail.com")}
            control={control}
          />
        </form>
        <LoadingButton
          type="submit"
          color="primary"
          isLoading={isPending}
          form="form_id"
        >
          {t("update profile")}
        </LoadingButton>
      </CardBody>
    </Card>
  )
}

export default UpdateProfilePage
